export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILURE = "GET_USERS_FAILURE";

export const DOWNLOAD_USER_TEMPLATE_REQUEST = "DOWNLOAD_USER_TEMPLATE_REQUEST";
export const DOWNLOAD_USER_TEMPLATE_SUCCESS = "DOWNLOAD_USER_TEMPLATE_SUCCESS";
export const DOWNLOAD_USER_TEMPLATE_FAILURE = "DOWNLOAD_USER_TEMPLATE_FAILURE";

export const DOWNLOAD_USER_REPORT_REQUEST = "DOWNLOAD_USER_REPORT_REQUEST";
export const DOWNLOAD_USER_REPORT_SUCCESS = "DOWNLOAD_USER_REPORT_SUCCESS";
export const DOWNLOAD_USER_REPORT_FAILURE = "DOWNLOAD_USER_REPORT_FAILURE";

export const UPLOAD_USERROFILE_REQUEST = "UPLOAD_USERPROFILE_REQUEST";
export const UPLOAD_USERROFILE_SUCCESS = "UPLOAD_USERROFILE_SUCCESS";
export const UPLOAD_USERROFILE_FAILURE = "UPLOAD_USERROFILE_FAILURE";

export const UPLOAD_USER_REQUEST = "UPLOAD_USER_REQUEST";
export const UPLOAD_USERROFILE_LOADER = "UPLOAD_USERROFILE_LOADER"
export const UPLOAD_USER_SUCCESS = "UPLOAD_USER_SUCCESS";
export const UPLOAD_USER_FAILURE = "UPLOAD_USER_FAILURE";

export const USER_FILE_UPLOAD_REQUEST = "USER_FILE_UPLOAD_REQUEST";
export const USER_FILE_UPLOAD_SUCCESS = "USER_FILE_UPLOAD_SUCCESS";
export const USER_FILE_UPLOAD_FAILURE = "USER_FILE_UPLOAD_FAILURE";

export const GET_DATA_TABLE_REQUEST = "GET_DATA_TABLE_REQUEST";
export const GET_DATA_TABLE_SUCCESS = "GET_DATA_TABLE_SUCCESS";
export const GET_DATA_TABLE_FAILURE = "GET_DATA_TABLE_FAILURE";

export const GET_SEARCH_FILTERS_REQUEST = "GET_SEARCH_FILTERS_REQUEST";
export const GET_SEARCH_FILTERS_SUCCESS = "GET_SEARCH_FILTERS_SUCCESS";
export const GET_SEARCH_FILTERS_FAILURE = "GET_SEARCH_FILTERS_FAILURE";

export const GET_EDIT_FORM_REQUEST = "GET_EDIT_FORM_REQUEST";
export const GET_EDIT_FORM_SUCCESS = "GET_EDIT_FORM_SUCCESS";
export const GET_EDIT_FORM_FAILURE = "GET_EDIT_FORM_FAILURE";

export const GET_VIEW_FORM_REQUEST = "GET_VIEW_FORM_REQUEST";
export const GET_VIEW_FORM_SUCCESS = "GET_VIEW_FORM_SUCCESS";
export const GET_VIEW_FORM_FAILURE = "GET_VIEW_FORM_FAILURE";

export const GET_USER_DATA_BY_ID_REQUEST = "GET_USER_DATA_BY_ID_REQUEST";
export const GET_USER_DATA_BY_ID_SUCCESS = "GET_USER_DATA_BY_ID_SUCCESS";
export const GET_USER_DATA_BY_ID_FAILURE = "GET_USER_DATA_BY_ID_FAILURE";

export const SAVE_USER_DATA_BY_ID_REQUEST = "SAVE_USER_DATA_BY_ID_REQUEST";
export const SAVE_USER_DATA_BY_ID_SUCCESS = "SAVE_USER_DATA_BY_ID_SUCCESS";
export const SAVE_USER_DATA_BY_ID_FAILURE = "SAVE_USER_DATA_BY_ID_FAILURE";

export const DELETE_RECORD_REQUEST = "DELETE_RECORD_REQUEST";
export const DELETE_RECORD_SUCCESS = "DELETE_RECORD_SUCCESS";
export const DELETE_RECORD_FAILURE = "DELETE_RECORD_FAILURE";

export const CREATE_NEW_RECORD_REQUEST = "CREATE_NEW_RECORD_REQUEST";
export const CREATE_NEW_RECORD_SUCCESS = "CREATE_NEW_RECORD_SUCCESS";
export const CREATE_NEW_RECORD_FAILURE = "CREATE_NEW_RECORD_FAILURE";

export const EXTERNAL_USER_INFO = "EXTERNAL_USER_INFO";